import { memo } from 'react';
import dynamic from 'next/dynamic';
import { Box, Text, useDisclosure, VStack } from '@chakra-ui/react';

const Service1cModal = dynamic(() => import('shared/Service1cModals/Service1cModal'));
import Illustration from './Illustration';

import { DEFAULT_BORDER_RADIUS } from 'constants/global';

const Service1cCard = ({
  title,
  subTitle,
  illustrationProps,
  ModalComponent = Service1cModal,
  modalData = null,
  ...props
}) => {
  const { isOpen: isModalOpen, onOpen: onModalOpen, onClose: onModalClose } = useDisclosure();

  return (
    <>
      <VStack
        role="group" //Нужен потому что внутри Illustration используется _groupHover
        as="button"
        w="full"
        minH={{ mobile: '300px', laptop: '320px' }}
        p={{ mobile: '20px', laptop: '40px' }}
        borderRadius={DEFAULT_BORDER_RADIUS}
        bgColor="bg.grayLight"
        pos="relative"
        align="start"
        textAlign="start"
        justify="space-between"
        overflow="hidden"
        transition="background-color .3s, color .3s"
        _hover={{ bgColor: 'bg.black', color: 'text.white' }}
        _focusVisible={{ bgColor: 'bg.black', color: 'text.white' }}
        _focus={{ outline: 'none' }}
        onClick={onModalOpen}
        {...props}
      >
        {/* Box нужен чтобы картинка не сжималась самостоятельно если её ширина больше чем ширина карточки */}
        <Box position="absolute" zIndex="0" {...illustrationProps}>
          <Illustration alt={`Иллюстрация карточки ${title}`} style={{ width: '100%', height: '100%' }} />
        </Box>

        <Text as="h3" fontSize={{ mobile: '24px', laptop: '32px' }}>
          {title}
        </Text>

        <VStack w="full" align="start" gap="12px">
          <Text textStyle="h1" fontWeight="500" fontSize={{ laptop: '24px' }}>
            {subTitle}
          </Text>

          <Text
            textStyle="button.secondary"
            textDecoration="underline"
            textUnderlineOffset="5px"
            _after={{ content: `'.'`, color: 'bg.accent' }}
          >
            Подробнее
          </Text>
        </VStack>
      </VStack>

      <ModalComponent isOpen={isModalOpen} onClose={onModalClose} title={title} {...modalData} />
    </>
  );
};

export default memo(Service1cCard);
